import React, { createContext, useContext, useState } from "react";

export const EMRContext = createContext();

export const EMRProvider = ({ children }) => {
  const [patientDetails, setPatientDetails] = useState(null);
  const [role, setRole] = useState("");
  const [complaintsData, setComplaintsData] = useState([]);
  const [allergiesData, setAllergiesData] = useState([]);
  const [diagnosisData, setDiagnosisData] = useState([]);
  const [surgeryData, setSurgeryData] = useState([]);
  const [pathologyData, setPathologyData] = useState([]);
  const [radiologyData, setRadiologyData] = useState([]);
  const [adviceData, setAdviceData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [medicationData, setMedicationData] = useState([]);
  const [pathology, setPathology] = useState(null);
  const [vital, setVital] = useState({});
  const [finalData, setFinalData] = useState(null);
  const [openPost, setOpenPost] = useState(false);
  const [divData, setDivData] = useState([]);
  const [departmentOption, setDepartmentOption] = useState([]);
  const [doctorOption, setDoctorOption] = useState([]);
  const [instractionDataResult, setInstractionDataResult] = useState([]);
  const [editData, setEditData] = useState(null);
  const [departmentCOption, setDepartmentCOption] = useState([]);
  const [doctorCoption, setdoctorCoption] = useState([]);
  const [AncAllergiesData, setAncAllergiesData] = useState([]);
  const [AncComplaintsData, setAncComplaintsData] = useState([]);
  const [AncDiagnosisData, setAncDiagnosisData] = useState([]);
  const [AncSurgeryData, setAncSurgeryData] = useState([]);
  const [openMedicationModal, setOpenMedicationModal] = useState(false);
  const BloodGroupData = [
    {
      id: "A+",
      label: "A+",
      value: "A+",
    },
    {
      id: "B+",
      label: "B+",
      value: "B+",
    },
    {
      id: "AB+",
      label: "AB+",
      value: "AB+",
    },

    {
      id: "O+",
      label: "O+",
      value: "O+",
    },
    {
      id: "A-",
      label: "A-",
      value: "A-",
    },
    {
      id: "B-",
      label: "B-",
      value: "B-",
    },

    {
      id: "AB-",
      label: "AB-",
      value: "AB-",
    },
    {
      id: "O-",
      label: "O-",
      value: "O-",
    },
    // {
    //   id: "Not Null",
    //   label: "Not Null",
    //   value: "Not Null",
    // },
  ];
  const checkBoxFields = [
    { name: "admission", label: "Admission", checked: false },
    { name: "physiotherapy", label: "Physiotherapy", checked: false },

    { name: "procedures", label: "Procedures", checked: false },
    { name: "Ref to consultant", label: "Ref to consultant", checked: false },
    { name: "other", label: "Other", checked: false },
  ];

  const [fields, setFields] = useState(checkBoxFields);
  const [dataAllergies, setDataAllergies] = useState([]);
  const [dataComplaints, setDataComplains] = useState([]);
  const [dataDiagnosis, setDataDiagnosis] = useState([]);
  const [dataSurgery, setDataSurgery] = useState([]);
  const [dataPathology, setDataPathology] = useState([]);
  const [dataRadiology, setDataRadiology] = useState([]);
  const [dataServices, setDataServices] = useState([]);
  const [openViewVitals, setOpenViewVital] = useState(false);
  const [openPatientHistory, setPatientHistory] = useState(false);
  const [doctomentData, setDocumentData] = useState([]);
  const [dataDocument, setDataDocument] = useState([]);
  const [openPartnerModal, setOpenPartnerModal] = useState(false);
  const [ancChecked, setAncChecked] = useState(false);
  const [isAncClose, setIsAncClose] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [base64Image, setBase64Image] = useState("");
  const [rowImage, setRowImage] = useState(null);
  const [image, setImage] = useState(null);
  const [open, setOpen] = useState(false);
  const [documentTypeList, setDocumentTypeList] = useState();
  const [dataMedication, setDataMedication] = useState([]);
  const [dataInstruction, setDataInstruction] = useState([]);
  const [instraction, setInstraction] = useState([]);
  const [vistitList, setVisitList] = useState([]);
  const [parentId, setParentId] = useState(null);
  const [isancFlag, setIsAncFlag] = useState(false);
  const [patientHistoryData, setPatientHistoryData] = useState(null);
  const [isDirty, setIsDirty] = useState(false);
  const [newDoc, setNewDoc] = useState(false);
  const [actions, setActions] = React.useState([]);
  const [dataRef, setDataRef] = useState([]);
  const [openFavorite, setOpenFavorite] = useState(false);
  const [markFavoriteData, setMarkFavoriteData] = useState();
  const [templateOption, setTemplateOption] = useState([]);
  const [isDraft, setIsDraft] = useState(false);
  const [weight, setWeight] = useState(null);
  const [height, setHeight] = useState(null);
  const [usgSonographyDetails, setUsgSonographyDetails] = React.useState([]);

  return (
    <EMRContext.Provider
      value={{
        patientDetails,
        setPatientDetails,
        role,
        setRole,
        complaintsData,
        setComplaintsData,
        allergiesData,
        setAllergiesData,
        diagnosisData,
        setDiagnosisData,
        surgeryData,
        setSurgeryData,
        pathologyData,
        setPathologyData,
        radiologyData,
        setRadiologyData,
        adviceData,
        setAdviceData,
        serviceData,
        setServiceData,
        medicationData,
        setMedicationData,
        pathology,
        setPathology,
        vital,
        setVital,
        BloodGroupData,
        finalData,
        setFinalData,
        openPost,
        setOpenPost,
        divData,
        setDivData,
        departmentOption,
        setDepartmentOption,
        doctorOption,
        setDoctorOption,
        instractionDataResult,
        setInstractionDataResult,
        editData,
        setEditData,
        fields,
        setFields,
        departmentCOption,
        setDepartmentCOption,
        doctorCoption,
        setdoctorCoption,
        AncAllergiesData,
        setAncAllergiesData,
        AncComplaintsData,
        setAncComplaintsData,
        AncDiagnosisData,
        setAncDiagnosisData,
        AncSurgeryData,
        setAncSurgeryData,
        dataAllergies,
        setDataAllergies,
        dataComplaints,
        setDataComplains,
        dataDiagnosis,
        setDataDiagnosis,
        dataSurgery,
        setDataSurgery,
        dataPathology,
        setDataPathology,
        dataRadiology,
        setDataRadiology,
        dataServices,
        setDataServices,
        openMedicationModal,
        setOpenMedicationModal,
        openViewVitals,
        setOpenViewVital,
        openPatientHistory,
        setPatientHistory,
        doctomentData,
        setDocumentData,
        dataDocument,
        setDataDocument,
        openPartnerModal,
        setOpenPartnerModal,
        ancChecked,
        setAncChecked,
        isAncClose,
        setIsAncClose,
        doctomentData,
        setDocumentData,
        dataDocument,
        setDataDocument,
        selectedFile,
        setSelectedFile,
        base64Image,
        setBase64Image,
        documentTypeList,
        setDocumentTypeList,
        dataMedication,
        setDataMedication,
        instraction,
        setInstraction,
        dataInstruction,
        setDataInstruction,
        vistitList,
        setVisitList,
        parentId,
        setParentId,
        isancFlag,
        setIsAncFlag,
        open,
        setOpen,
        image,
        setImage,
        patientHistoryData,
        setPatientHistoryData,
        isDirty,
        setIsDirty,
        newDoc,
        setNewDoc,
        actions,
        setActions,
        dataRef,
        setDataRef,
        markFavoriteData,
        setMarkFavoriteData,
        openFavorite,
        setOpenFavorite,
        templateOption,
        setTemplateOption,
        isDraft,
        setIsDraft,
        weight,
        setWeight,
        height,
        setHeight,
        usgSonographyDetails,
        setUsgSonographyDetails,
      }}
    >
      {children}
    </EMRContext.Provider>
  );
};

export const useEMRContext = () => useContext(EMRContext);

